/* global axios */

import ApiClient from './ApiClient';

const buildFormData = data => {
  const formData = new FormData();
  if (data.short_code) formData.append('short_code', data.short_code);
  if (data.content !== undefined && data.content !== null) {
    formData.append('content', data.content);
  }
  if (data.file) formData.append('file', data.file);
  if (data.remove_file) formData.append('remove_file', 'true');
  if (data.enabled !== undefined) {
    formData.append('enabled', data.enabled);
  }
  return formData;
};

class CannedResponse extends ApiClient {
  constructor() {
    super('canned_responses', { accountScoped: true });
  }

  get({ searchKey }) {
    const url = searchKey ? `${this.url}?search=${searchKey}` : this.url;
    return axios.get(url);
  }

  create(data) {
    if (data.file || data.remove_file) {
      return axios.post(this.url, buildFormData(data), {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    }
    return axios.post(this.url, data);
  }

  update(id, data) {
    if (data.file || data.remove_file) {
      return axios.patch(`${this.url}/${id}`, buildFormData(data), {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    }
    return axios.patch(`${this.url}/${id}`, data);
  }
}

export default new CannedResponse();
